import * as _ from "lodash";

export interface ISerializable {
    data: { mainItem?: string; comparedItems?: string[] };
}

export const serializeItems = (value: ISerializable): string | undefined => {
    if (value.data?.comparedItems && value.data.comparedItems.length > 0) {
        const normalizedMainItem = value.data?.mainItem?.toLowerCase();
        const normalizedComparedItems = value.data?.comparedItems?.map((item: string) => item.toLowerCase()).sort();
        const serializedItems = _.join([
            normalizedMainItem,
            ...(normalizedComparedItems ? normalizedComparedItems : []),
        ]);
        return serializedItems;
    } else {
        return value.data?.mainItem?.toLowerCase();
    }
};

export const dedupRecent = (
    recentWebsite: ISerializable[],
    serializeItemsFunction: (value: ISerializable) => string | undefined = serializeItems,
) => {
    return _.uniqBy<ISerializable>(recentWebsite, serializeItemsFunction);
};

/**
 * Serializes only the main item, ignoring compared items.
 * Used for Ad Intelligence where compare mode is not displayed in recents.
 */
export const serializeMainItemOnly = (value: ISerializable): string | undefined => {
    return value.data?.mainItem?.toLowerCase();
};
